import API from '../../Api';
import {
  DistanceRequest,
  EditOrderRequestCart,
  ItemTotalsPayloadInteface,
  UpdateOrderTip,
} from './orderModels';
import { GetOrderDetails } from '../cart/cartModels';
import { encryptJson, handleEncrypt } from '../../utils/react-ec-utils';

// Get a Order Detail
// export function getOrderDetails(orderData: GetOrderDetails) {
//   const enOrderId = handleEncrypt(orderData?.orderId);

//   return API({
//     method: "get",
//     url: "/api/customers/order/customer",
//     params: orderData.sortOrder
//       ? { data: enOrderId, sortOrder: orderData.sortOrder }
//       : {
//         data: enOrderId,
//         },
//   });
// }

export function getOrderDetails(orderData: GetOrderDetails) {
  // Validate required fields
  if (!orderData?.orderId) {
    throw new Error('Order ID is required');
  }

  const payload = {
    orderId: orderData.orderId,
    splitId: orderData?.splitId,
    sortOrder: orderData?.sortOrder,
    transactionId: orderData?.transactionId,
  };

  const enOrderId = encryptJson(payload);
  return API({
    method: 'post',
    url: '/api/customers/order/customer',
    data: { data: enOrderId },
  });
}

// Get Customer Orders
export function getOrders(customerId: string) {
  return API({
    method: 'get',
    url: '/order/getOrders',
    params: {
      search: `customerId:${customerId}`,
      sort: 'orderDate,desc',
    },
  });
}

// Get past experience customer orders
export function getLatestOrders(customerId: string) {
  return API({
    method: 'get',
    url: '/order/customer/getOrders?sort=orderDate,desc',
    params: {
      search: `customerId:${customerId}`,
      page: '0',
      size: '1000',
      sort: 'orderTime,desc',
    },
  });
}

// For Floating Bar
export function getActiveOrders(customerId: string) {
  let data = encryptJson({
    search: `customerId:${customerId}`,
    page: 0,
    size: 1000,
    sort: 'orderTime,desc',
  });
  return API({
    method: 'post',
    url: '/api/customers/order/filter',
    data: { data: data },
  });
}

// Calculate Distance
export function getDistanceBtwResUser(details: DistanceRequest) {
  const detailsData = encryptJson(details);
  return API({
    method: 'post',
    url: '/api/customers/order/getDistance',
    data: { data: detailsData },
  });
}

export function updateOrderAPI(cartData: EditOrderRequestCart) {
  const data = encryptJson(cartData);

  return API({
    method: 'put',
    url: '/api/customers/order/update',
    data: { data: data },
    // headers: getAuthHeader(),
  });
}

export function updateOrderTipAPI(cartData: UpdateOrderTip) {
  const data = encryptJson({
    orderId: cartData.orderId,
    tip: cartData.tipAmount,
    tipType: cartData.tipType ? cartData.tipType : 'FLATFEE',
  });
  return API({
    method: 'put',
    url: `/api/customers/order/add-tip`,
    data: { data: data },
    //url: `/order/${cartData.orderId}/totals/tip?tip=${cartData.tipAmount}&tipType=${cartData.tipType?cartData.tipType :"FLATFEE"}&transactionId=${cartData.transactionId}`,
  });
}

export function getKDSOrderDetailAPI(orderId: any) {
  const data = encryptJson({
    orderId: orderId?.orderId,
    splitId: orderId?.splitId ?? '',
    transactionId: orderId?.transactionId,
  });
  return API({
    method: 'post',
    url: '/api/customers/order/getKOTItemsBySortOrder',
    data: { data: data },
  });
}

export function getFilteredOrders(phone: string) {
  let data = encryptJson({ search: `phone:${phone}`, page: 0, size: 1000, sort: 'orderTime,desc' });
  return API({
    method: 'post',
    url: '/api/customers/order/filter',
    data: { data: data },
  });
}

export function manageItemTotalsApi(payload: ItemTotalsPayloadInteface) {
  const data = encryptJson(payload);
  return API({
    method: 'post',
    url: '/api/customers/order/totals',
    data: { data: data },
  });
}

export function customerOrders(payload: any) {
  const data = encryptJson(payload);
  return API({
    method: 'get',
    url: `/api/customers/orders?customerId=${payload.CustomerId}&locationId=${payload.locationId}`,
    // data: { "data": data},
  });
}
export function currentOrder(payload: any) {
  const data = encryptJson(payload);
  return API({
    method: 'get',
    url: `/api/customers/order/getOrder?orderId=${payload}`,
    // data: { "data": data},
  });
}
// curl --location 'http://localhost:9081/magilhub-data-services/api/customers/orders?customerId=10873b07-5baa-4b2f-bbc8-da2c07df8c8c&locationId=d15139f6-ea2b-4b4c-8541-7a9112bfd8bf'
